module.exports = __webpack_public_path__ + "media/images/gifts/art/sug_arte_6-bf92111a5d5a114af9024323eb09bf0e.jpg";